import getAnneeSemaineFromDate from '@/services/general/getAnneeSemaineFromDate';

export default function multiActionLogistiqueGetter(ligneCommande) {
  if (!ligneCommande || !ligneCommande.demandesLogistique) {
    return false;
  }
  let anneeSemaineAffichage;
  if (ligneCommande.datePlanifieeLogistiqueAffichage) {
    anneeSemaineAffichage = getAnneeSemaineFromDate(
      ligneCommande.datePlanifieeLogistiqueAffichage,
    );
  }
  if (!anneeSemaineAffichage
    && ligneCommande.ligneReseau
    && ligneCommande.ligneReseau.anneeSemaine) {
    anneeSemaineAffichage = ligneCommande.ligneReseau.anneeSemaine.toString();
  }
  if (!anneeSemaineAffichage && ligneCommande.dateDebut) {
    anneeSemaineAffichage = getAnneeSemaineFromDate(
      ligneCommande.dateDebut,
    );
  }
  if (!anneeSemaineAffichage) return false;
  return ligneCommande.demandesLogistique.some(demande => {
    const anneeSemaineDemande = getAnneeSemaineFromDate(demande.datePlanification);
    return anneeSemaineDemande === anneeSemaineAffichage;
  });
}
